export default __webpack_public_path__ + "static/media/homeSong.6b930a3d.mp3";